"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSIClientV1 = void 0;
const responses_1 = require("./responses");
const getSIClientV1 = ({ accessToken, env, options: globalOptions }) => {
    return {
        getResponseById: async (id) => {
            return (0, responses_1.getResponseById)(accessToken, id, env, globalOptions);
        },
        getSIResponseByUrl: async (url) => {
            return (0, responses_1.getResponseByUrl)(accessToken, url, globalOptions);
        },
        postResponse: async (siResponse) => {
            return (0, responses_1.postResponse)(accessToken, siResponse, env, globalOptions);
        },
    };
};
exports.getSIClientV1 = getSIClientV1;
